<template>
  <transition name="slide-fade">
    <v-container fluid>
      <view-invoice :invoice="invoice"></view-invoice>
      <v-layout wrap class="noprint justify-end mb-10 pb-10">
        <v-flex xs12 sm6 md6 order-xs2 class="pa-1">
          <v-card v-show="invoice.status != 'PAID'">
            <v-card-title class="py-0" style="/*background: #0494e4;*/">
              <!-- <v-avatar> -->
                <img src="/images/PayPal.svg" alt="PayPal logo" height="32px" contain>
              <!-- </v-avatar> -->
              <v-spacer></v-spacer>
              USD {{ USD }}
            </v-card-title>
            <v-card-text>
              <hr class="transparent">
              <div id="paypal-button-rendered"></div>
              <div><p>Currently not available. Please use MPESA to make payments.</p></div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 sm6 class="pa-1">
          <v-card flat>
            <v-card-title class="py-1">
              <v-btn v-if="invoice.status != 'PAID' && !canEdit" small title="Enter Transaction Details Manually" text outlined @click="goTo('/invoices/' + invoice.id + '/edit')">Enter Transaction Details</v-btn>
              <v-spacer></v-spacer>
              <v-btn small title="Query Status" @click="queryMpesa()" text outlined class="ml-1" color="warning" v-show="invoice.status != 'PAID'">
                Query Status
              </v-btn>
              <v-btn v-if="canEdit" small text outlined @click="goTo('/invoices/' + invoice.id + '/edit')" title="Edit Invoice">
                <v-icon left>mdi-content-save-edit</v-icon>Edit
              </v-btn>
            </v-card-title>
            <v-card-actions v-if="errors && errors.payRequest">
              <v-spacer></v-spacer>
              <span class="red--text" v-if="errors.payRequest.amount">{{ errors.payRequest.amount }}</span>
            </v-card-actions>
          </v-card>
          <v-divider v-show="invoice.status != 'PAID'"></v-divider>
          <v-card v-show="invoice.status != 'PAID'">
            <v-card-title class="py-0 pl-0" @click="showMpesa = !showMpesa">
              <img src="/images/mpesa.svg" lazy-src="/images/placeholder.gif" height="30px">
              <v-spacer></v-spacer>
              Pay With M-Pesa
            </v-card-title>
            <v-card-text v-show="showMpesa">
              <form @submit.prevent="payMpesa(mpesa)">
                <v-text-field label="Mpesa Phone Number" v-model="mpesa.phone" required="required" placeholder="254722xxxxxx" inputmode="numeric" minlength="12" maxlength="12" :counter="12" hint="Enter a valid MPESA number. Start with 254."></v-text-field>
                <p class="ma-0">Please confirm that the organization receiving money is <code>PRIMACY AID HEALTHCARE LIMITED</code></p>
                <v-btn type="submit" color="green" :loading="mpesa.processing" class="pull-right" :disabled="!mpesa.phone || mpesa.phone.length != 12">
                  <v-icon left>mdi-content-save</v-icon>
                  Next
                </v-btn><br>
              </form>
            </v-card-text>
            <v-sheet class="pa-1" v-show="showMpesa">
              We will send a payment request to your phone for KShs. {{ invoice.net }}. Please enter your pin at the request to complete the payment. <br> If the request doesn't appear on your phone, pay using Till Number <code>5245351</code>, amount <code>{{ invoice.net }}</code>, and use the <v-btn x-small title="Enter Transaction Details Manually" text outlined @click="goTo('/invoices/' + invoice.id + '/edit')">Enter Transaction Details</v-btn> to update your payment details.
            </v-sheet>
            <v-card-actions class="py-1" v-if="!KES || !USD">
              <v-spacer></v-spacer>
              <v-btn x-small outlined @click="checkConversion" text color="primary">Currency Conversions</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'
  const ViewInvoice = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "invoices" */ '@/Components/Invoices/invoice')

  export default {
    name: 'InvoiceShow',
    layout,
    props: {
      invoice: {
        default: {}
      },
      page_type: {
        default: 'auth'
      },
      canEdit: {
        type: Boolean,
        default: false
      },
      message: {
        default: '',
      },
      errors: {
        default: null
      },
      redirect: {
        default: null
      }
    },
    components: {
      ViewInvoice,
    },
    metaInfo () {
      return {
        title: 'Invoice',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        mpesa: this.$inertia.form({
          phone: '254'
        }),
        showMpesa: true,
      }
    },
    methods: {
      payMpesa (mpesa) {
        swal({
          title: 'Initiate Payment?',
          text: 'Make sure your phone is turned on.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Send',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          var vm = this
          this.$inertia.post('/pay/invoices/' + this.invoice.id + '?channel=mpesa', {
            phone: mpesa.phone,
            amount: this.invoice.net
          },
          {
            preserveScroll: false,
            onFinish: () => {
              swal.close()
            },
            onSuccess: () => {
              setTimeout(() => {
                vm.$inertia.reload()
              }, 120000)
            }
          })
        }.bind(this))
      },
      queryMpesa () {
        this.$inertia.post('/pay/invoices/' + this.invoice.id + '/stk-query', {}, {
          preserveScroll: false,
          onFinish: () => {
            //
          },
          onSuccess: () => {
            swal(message)
          }
        })
      },
      renderPaypal () {
        let test = typeof(paypal)
        let vm = this
        // console.log(test);
        if (test == 'undefined') {
          let retries = 1
          this.$message = `Paypal could not be loaded!<br> Tried ${retries} times<br> Retrying in 5 seconds...`
          setTimeout(() => {
            if (retries < 11) {
              vm.renderPaypal()
            }
          }, 5000)
          retries++
          return
        }

        paypal.Buttons({
          style: {
            color:  'gold',
            shape:  'pill',
            label:  'pay',
            height: 40
          },
          onInit: function(data, actions)  {
            // Disable the buttons
            actions.disable();
            if (vm.USD > 0) {
              actions.enable()
            }
          },
          createOrder: function(data, actions) {
            // This function sets up the details of the transaction, including the amount and line item details.
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: vm.USD,
                  currency_code: 'USD'
                },
                invoice_id: vm.invoice.id,
                reference_id: vm.invoice.id,
                description: vm.invoice.description,
              }]
            });
          },
          onApprove: function(data, actions) {
            // console.log('paypal onapprove', data, actions);
            // This function captures the funds from the transaction.
            return actions.order.capture().then(function(details) {
              // console.log(details);
              let payer = details.payer.name.given_name
              let transaction = details.purchase_units[0].payments.captures[0]
              let id = transaction.id;
              let time = transaction.create_time
              swal('Payment completed. <br>Transaction ID <code class="red--text">' + id + '</code><br>Paid by <code>' + payer + '</code><br>' + time)

              // console.log(payer, transaction)
              vm.$inertia.put('/pay/invoices/' + vm.invoice.id + '/paypal', details, {
                onSuccess: () => {}
              })
              // This function shows a transaction success message to your buyer.
              // alert('Transaction completed by ' + details.payer.name.given_name);
            });
          },
          onCancel: function (data) {
            // console.log('Paypal Cancelled', data);
            swal('Error','Failed to Pay. <br> User cancelled payment.','error')
          },
          onError: function (err) {
            // console.error('Paypal Error', err);
            swal('Error','An error occured. <br>Please try again later. <br>If you\'ve already paid, enter transaction ID from Paypal by clicking the edit button','error')
          }
        }).render('#paypal-button-rendered');
      },
      checkConversion () {
        if (!this.USD || !this.KES) {
          this.$inertia.post('/pay/invoices/' + this.invoice.id + '/conversion')
        }
      }
    },
    mounted () {
      if (this.invoice.check_type) {
        this.showMpesa = false
      }
      this.$nextTick(() => {
        if (this.invoice.status != 'PAID') {
          // this.renderPaypal()
          this.checkConversion()
        }
        if (this.invoice.status == 'PAID') {
          if (this.redirect) {
            location.href = this.redirect
          }
        }
      })
      // this.somemethod()
      // console.log({"Body":{"stkCallback":{"MerchantRequestID":"25296-17509106-1","CheckoutRequestID":"ws_CO_160720211630556993","ResultCode":0,"ResultDesc":"The service request is processed successfully.","CallbackMetadata":{"Item":[{"Name":"Amount","Value":1.0},{"Name":"MpesaReceiptNumber","Value":"PGG9F1GJRB"},{"Name":"Balance"},{"Name":"TransactionDate","Value":20210716163109},{"Name":"PhoneNumber","Value":254729719467}]}}}});
    },
    computed: {
      recipient () {
        return this.invoice.recipient
      },
      user () {
        return this.invoice.user
      },
      USD () {
        let details = this.invoice.details
        if (details?.currency?.USD) {
          return details.currency.USD.toFixed(2)
        }
        return null
      },
      KES () {
        let details = this.invoice.details
        if (details?.currency?.KES) {
          return details.currency.KES.toFixed(2)
        }
        return null
      }
    },
    watch: {
      'invoice.status': function (value) {
        if (value == 'PAID') {
          if (this.redirect) {
            location.href = this.redirect
          }
        }
      }
    },
    beforeCreate () {
      let test = typeof(paypal)
      if (test == 'undefined') {
        var paypalkey = document.querySelector('meta[name=paypal-key]').getAttribute('content')
        var PAYPAL_SCRIPT = `https://www.paypal.com/sdk/js?client-id=${paypalkey}`;
        var script = document.createElement('script');
        script.setAttribute('src', PAYPAL_SCRIPT);
        document.head.appendChild(script);
      }
    }
  }
</script>

<style>
  .invoice-body {
    border: 1px solid;
    margin-top: 10px;
  }
  .total {
    text-decoration-skip-ink: none;
    text-decoration-line: underline;
    text-decoration-style: double;
  }
</style>
